import { stylesheet } from "typestyle";

export default stylesheet({
  mainContainer: {
    padding: "57px",
  },
});
